import { Table } from 'antd';
import Card from 'react-bootstrap/Card';
import { Link } from 'react-router-dom';
import Moment from 'react-moment';
import 'moment-timezone';
import { useEffect, useState } from 'react';
import { BiRupee } from 'react-icons/bi';
import axiosinterce from '../function/axiosInterceptor';
import Swal from 'sweetalert2';
import { toast } from 'react-toastify';
const Donation_List = () => {
    let amt = 0;
    const [donation, getDonation] = useState([]);
    const columns = [
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: 'Phone',
            dataIndex: 'phone',
            key: 'phone',
        },
        {
            title: 'Email',
            dataIndex: 'email',
            key: 'email',
        },

        {
            title: 'Amount',
            dataIndex: 'amount',
            key: 'amount',
        },

        {
            title: 'Donation date',
            dataIndex: 'dates',
            key: 'dates',
        },
        {
            title: 'Action',
            dataIndex: 'action',
            key: 'action',
        },
    ];
    const data = [];
    const fatchData = async () => {
        try {
            const response = await axiosinterce.get('/admin/donations')
            if (response.status === 1) {
                getDonation(response.data);
            }
        } catch (err) { }
    }
    donation && donation.map((info, i) => {
        amt += donation[i].amount;
        data.push({
            key: i + 1,
            name: info.name,
            phone: info.phone || '--',
            email: info.email || '--',
            amount: <div className="Container" dangerouslySetInnerHTML={{ __html: '<span>&#8377;</span> ' + info.amount }}></div>,
            dates: <Moment format="DD/MMMM/YYYY">{info.donation_date}</Moment>,
            action: info.status===0?<><button className='btn btn-sm btn-success' onClick={() => manageApproval({...info, status: 1 })}>Approved</button><button className='btn btn-sm btn-danger' onClick={() => manageApproval({...info, status: 2 })}>Reject</button></>:<span className={info.status==1?'text-success':'text-danger'}>{info.status==1?"Approved":"Reject"}</span>,
            description: <table>
                <tr>
                    <td><strong>Transaction Id :</strong> {info.transaction_id}</td>
                    <td><strong>User Id :</strong> {info.user_id}</td>
                    <td><strong>Pan No :</strong> {info.pan}</td>
                </tr>
                <tr>
                    <td colspan="3"><strong>Address :</strong> {info.address + ', ' + info.post + ', ' + info.city + ', ' + info.state + ', ' + info.country + ', ' + info.pin}</td>
                </tr>
                <tr>
                    <td colspan="3"><strong>Exact Time :</strong> <Moment format="DD/MMMM/YYYY ">2015-02-01T00:00:00</Moment></td>
                </tr>
            </table>
        });
    })
    const manageApproval = async (ref) => {
        const swalWithBootstrapButtons = Swal.mixin({ customClass: { confirmButton: "btn btn-success", cancelButton: "btn btn-danger" }, buttonsStyling: false });
        swalWithBootstrapButtons.fire({
            title: "Are you sure?",
            text: `You won't to ${ref?.status==1?"approved":"reject"} this donation.`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: ref?.status==1?"Yes, Approved":'Yes, Reject',
            cancelButtonText: "No, cancel!",
            reverseButtons: true
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const { sno, status } = ref
                    const response = await axiosinterce.post('/admin/donation/aprrovel', { id: sno, status });
                    if (response.status === 1) {
                        fatchData()
                        toast.success(response.message, { position: 'top-center', autoClose: 700 })
                    } else {
                        toast.warn(response.message, { position: 'top-center', autoClose: 700 })
                    }
                } catch (err) {
                    toast.error(err.message, { position: 'top-center', autoClose: 700 })
                }
            }
        });
    }
    useEffect(() => { fatchData() }, []);
    return (<>
        <Card>
            <Card.Header>Donation List</Card.Header>
            <Card.Body>
                <div className='d-flex justify-content-between'>
                    <div className=''>
                        <p className="text-muted mb-3">Total Amount :<code><BiRupee />{amt}.00</code>,
                            <span> Donation: <code>{donation.length < 10 ? '0' + donation.length : donation.length}</code></span>
                        </p>
                    </div>
                    <div>
                        <Link to="/admin/donation-grid"><button className='custom-btn'>Donation Grid</button></Link>
                    </div>
                </div>
                <Table
                    columns={columns}
                    expandable={{
                        expandedRowRender: (record) => (
                            <p
                                style={{
                                    margin: 0,
                                }}
                            >
                                {record.description}
                            </p>
                        ),
                        rowExpandable: (record) => record.name !== 'Not Expandable',
                    }}
                    dataSource={data}
                />
            </Card.Body>
        </Card>
    </>);
};
export default Donation_List;